import "./scss/style.scss";
import imageSlider from "./js/imageSlider";
import addToCart from "../elsa-shop/js/addToCart";
import loadCart from "../elsa-shop/js/loadCart";
import removeCart from "../elsa-shop/js/removeCart";
import formHandler from "../elsa-shop/js/form";

$(function () {
  addToCart();
  loadCart();
  removeCart();
  imageSlider();
  formHandler();
});
